import React, { useState, useEffect } from 'react';
import {
    CCard,
    CCardBody,
    CCardTitle,
    CCardText,
    CFormTextarea,
    CButton,
    CFormSwitch,
    CRow,
    CCol,
    CFormSelect
} from '@coreui/react';
import CookieFunctions from '../functions/CookieFunctions';
import { toast } from 'react-toastify';

export default function Feedback() {


    const [feedback, setFeedback] = useState('');
    const [isAnonymous, setIsAnonymous] = useState(false);
    const [feedbackCategory, setFeedbackCategory] = useState('General'); 
    const [errors, setErrors] = useState([]);
    const [showReviewOption, setShowReviewOption] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false); 
    const MAX_FEEDBACK_LENGTH = 1000;

    const handleFeedbackChange = (event) => {
        const newFeedback = event.target.value;

        if (newFeedback.length > MAX_FEEDBACK_LENGTH) {
            setErrors([`Feedback cannot exceed ${MAX_FEEDBACK_LENGTH} characters`]);
        } else {
            setFeedback(newFeedback);
            setErrors([]);
        }
    };

    const handleAnonymousToggle = () => {
        setIsAnonymous(!isAnonymous);
    };

    const handleFeedbackCategoryChange = (event) => {
        setFeedbackCategory(event.target.value);
    };

    useEffect(() => {
        const hireDate = new Date(CookieFunctions.getHireDate());
        const currentDate = new Date();
        const date90DaysAgo = new Date(currentDate);
        date90DaysAgo.setDate(date90DaysAgo.getDate() - 90);

        setShowReviewOption(hireDate >= date90DaysAgo);
    }, []);

    useEffect(() => {
        setErrors([]);
    }, [feedback]);

    const handleSubmit = () => {
        if (!feedback.trim()) {
            setErrors(["Feedback cannot be empty! "]);
            return;
        }

        setIsSubmitting(true); 

        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();

        formData.append("comments", feedback)
        formData.append("isAnonymous", isAnonymous)
        formData.append("category", feedbackCategory)

        fetch("/api/feedback/submitFeedback", {
            headers: myHeaders,
            method: 'POST',
            body: formData
        }).then((res) => {
            if (res.ok) {
                toast.success("Feedback submitted successfully!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored",
                });
                setFeedback("");
                setFeedbackCategory('General'); 
                setIsSubmitting(false); 
            } else if (res.status === 400) {
                return res.text()
            }
        }).then((data) => {
            if (data) {
                setErrors(["Unable to process your request. Please try again."])
            }
        });
    };

    return (
        <CCard className="mb-4">
            <CCardBody>
                <CCardTitle className='fs-2'>Questions & Feedback</CCardTitle>
                <CCardText className='fs-5'>Please use this page to submit any questions, ideas, or feedback to Titanium. If you’d like your feedback to be anonymous, choose the Anonymous option below.</CCardText>

                <CRow>
                    <CCol sm="2" className="my-2">
                        <CCardText className='fs-5' style={{ marginBottom: '8px', marginTop: '8px' }}>Feedback Type:</CCardText>
                    </CCol>
                    <CCol sm="3" className="my-1">
                        <CFormSelect
                            custom
                            id="feedbackCategorySelect"
                            value={feedbackCategory}
                            onChange={handleFeedbackCategoryChange}
                            style={{ marginBottom: '8px', marginTop: '8px' }}
                        >
                            <option value="Dispatch Related">Dispatch Related (i.e. missing trips on paystub)</option>
                            <option value="Driver Portal Related">Driver Portal Related</option>
                            <option value="Fuel Related">Fuel Related</option>
                            <option value="General">General</option>
                            <option value="Maintenance">Maintenance</option>
                            <option value="Pay Related">Pay Related (i.e. changing bank info, tax questions)</option>
                            {showReviewOption && <option value="45/75 Review">45/75 Review (For new hires)</option>}
                        </CFormSelect>
                    </CCol>
                </CRow>

                <CFormTextarea
                    placeholder="Type your suggestion or feedback here (maximum 1000 characters)"
                    value={feedback}
                    onChange={handleFeedbackChange}
                    style={{ marginBottom: '10px', marginTop: '8px', minHeight: '200px' }}
                />
                {errors.length !== 0 ?
                    <CCol sm="12">
                        {errors.map((error, i) => {
                            return <CCardText key={i} style={{ color: 'red', fontWeight: '600', fontSize: '20px' }}>{error}</CCardText>
                        })}
                    </CCol> : null}

                

                <CFormSwitch
                    size="lg"
                    id="formSwitchCheckDefault"
                    label="Anonymous"
                    checked={isAnonymous}
                    onChange={handleAnonymousToggle}
                />

                <CButton
                    color="primary"
                    className="mt-3"
                    onClick={handleSubmit}
                    disabled={isSubmitting} 
                >
                    Submit
                </CButton>
            </CCardBody>
        </CCard>
    );
}
